"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ukPoliceDataReducer = void 0;
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../redux/state");
const ukPoliceDataReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_POLICEDATA_ERROR' }, _action => state.update(state_1.stateKeys.policeData, _state => ({
    ..._state,
    error: _action.payload
})))
    .with({ type: 'SET_POLICEDATA_GEOLOCATION' }, _action => state.update(state_1.stateKeys.policeData, _state => ({
    ..._state,
    value: {
        ..._state.value,
        geoLocation: _action.payload
    }
})))
    .with({ type: 'SET_POLICEDATA_LOCATION' }, _action => state.update(state_1.stateKeys.policeData, _state => ({
    ..._state,
    value: {
        geoLocation: _state.value.geoLocation,
        locations: {
            ..._state.value.locations,
            ..._action.payload
        }
    }
})))
    .exhaustive();
exports.ukPoliceDataReducer = ukPoliceDataReducer;
//# sourceMappingURL=reducer.js.map